import Price from "../common/Price";
import {SuggestedAssetPriceApiDto} from "../../api/model/rest";

export default class SuggestedAssetPrice {
	constructor(public readonly sellPrice: Price,
		public readonly sellUnitPrice: Price) {}

	static fromJson(json: SuggestedAssetPriceApiDto) {
		return new SuggestedAssetPrice(Price.fromJson(json.sellPrice), Price.fromJson(json.sellUnitPrice))
	}
}